/**
 * Satellite / checkbox rubric: API sets rubricCheckboxScoring on the rubric payload.
 * Checked = full category points; unchecked = 0.
 */
export function isRubricCheckboxScoring(rubric) {
  if (!rubric) {
    return false;
  }
  const rawValue = rubric.rubricCheckboxScoring ??
    rubric.checkboxScoring ??
    rubric.rubric_checkbox_scoring ??
    rubric.data?.rubricCheckboxScoring ??
    rubric.data?.checkboxScoring;

  if (typeof rawValue === 'string') {
    const normalizedValue = rawValue.trim().toLowerCase();
    return normalizedValue === 'true' || normalizedValue === '1' || normalizedValue === 'y' || normalizedValue === 'yes';
  }
  if (typeof rawValue === 'number') {
    return rawValue === 1;
  }
  return Boolean(rawValue);
}

export function isRubricCategoryFullyChecked(category) {
  if (!category || category.maxPoints == null || category.maxPoints === '') {
    return false;
  }
  const score = parseFloat(category.calculatedTempScore);
  const max = parseFloat(category.maxPoints);
  if (Number.isNaN(score) || Number.isNaN(max)) {
    return false;
  }
  return score >= max - 0.001;
}
